<div #textArea
     contenteditable="true"
     (input)="onInput($event)"
     (blur)="onBlur()"
     (focus)="onFocus()"
     (paste)="onPaste($event)"
>
</div>



// WEBPACK FOOTER //
// ./src/app/text/text.view.div.component.html